{
  "header": "Butiran Aset",
  "subtitle": "Aset yang dilampirkan pada trak anda (treler, kontena, dan lain-lain).",
  "assetType": "Jenis Aset",
  "assetTypePlaceholder": "Pilih Jenis Aset",
  "assetId": "ID Aset (cth. Nombor Treler)",
  "assetIdPlaceholder": "Cth: Nombor treler, ID Kontena, dan lain-lain",
  "remove": "Buang",
  "addAnother": "Tambah aset lain",
  "trailerType": "Jenis treler",
  "trailerId": "ID Treler"
}
